"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    containerVariants: ()=>containerVariants,
    tableVariants: ()=>tableVariants
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const tableVariants = (0, tv_cjs_namespaceObject.tv)({
    base: 'divide-neutral-5 w-full border-separate border-spacing-0 divide-y',
    slots: {
        container: ''
    },
    variants: {
        bordered: {
            true: {
                base: 'rounded-xl',
                container: 'border-1 border-primary-5 overflow-hidden rounded-xl'
            }
        },
        scrollable: {
            true: {
                container: 'no-scrollbar overflow-auto'
            }
        }
    },
    defaultVariants: {
        bordered: false,
        scrollable: false
    }
});
const containerVariants = (0, tv_cjs_namespaceObject.tv)({
    variants: {
        bordered: {
            true: 'border-1 border-primary-5 overflow-hidden rounded-xl'
        },
        scrollable: {
            true: 'no-scrollbar overflow-auto'
        }
    },
    defaultVariants: {
        bordered: false,
        scrollable: false
    }
});
exports.containerVariants = __webpack_exports__.containerVariants;
exports.tableVariants = __webpack_exports__.tableVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "containerVariants",
    "tableVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
